import { useNetworkStatusStore } from "@/zustand/networkStatusStore";
import OpticksButton from "../OpticksButton/OpticksButton";
import "./NetworkStatusOverlay.css";

const NetworkStatusOverlay = () => {
  const isNetworkDown = useNetworkStatusStore((state) => state.isNetworkDown);

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div
      className={`network-overlay ${isNetworkDown ? "network-overlay--visible" : ""}`}
    >
      <div className="network-overlay__card">
        <div className="network-overlay__icon">&#128268;</div>
        <h4 className="network-overlay__title">Connection lost</h4>
        <p className="network-overlay__message">
          It looks like your internet connection dropped. <br />
          Please check your connection and try again.
        </p>
        <OpticksButton
          onClick={handleRetry}
          variation="primary"
          label="Retry"
        />
      </div>
    </div>
  );
};

export default NetworkStatusOverlay;
